import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

const TableHeaderCell = ({ width, backgroundColour, children, className }) => {
  return <th className={className}>{children}</th>;
};

// === TableHeaderCell CSS ===
const StyledTableHeaderCell = styled(TableHeaderCell)`
  font-weight: ${vars.fontWeightMedium};
  ${({ width }) => (width ? `width: ${width};` : null)}
  ${({ backgroundColour }) =>
    backgroundColour ? `background-colour: ${backgroundColour};` : null}
  border-bottom: 1px solid ${vars.borderGrey};
`;

export default StyledTableHeaderCell;
